var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logout",on:{"click":function($event){return _vm.client.logOut()}}},[_c('img',{attrs:{"src":require("@/assets/img/icons/profile_logout_icon.svg"),"alt":"Log out"}}),_vm._v(" "+_vm._s(_vm.$t('PROFILE.LOGOUT'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }